module.exports = __webpack_public_path__ + "static/media/clientPhoto8.563a8aab.png";